<script lang="ts">
    import type {Link} from '../../../typings/portaro.be.types';
    import {resolveTarget, resolveHref} from './link-utils';
    import {pipe} from '../../../svelte/utils';
    import {loc} from '../../../svelte/pipes';

    export let link: Link;
    export let buttonSize: 'xs' | 'sm' | 'md' | 'lg';
    export let buttonStyle: 'default' | 'primary' | 'success' | 'danger';

    const buttonClass = `btn-${buttonStyle} btn-${buttonSize}`;
</script>

<template>
    <a href={resolveHref(link)}
       target={resolveTarget(link)}
       class="btn {buttonClass}">
        {pipe(link, loc())}
    </a>
</template>